export default {
    list: {
        title: 'Accounts',
        subtitle: 'Manage international legal entities',
        newAccount: 'New Account',
        loading: 'Loading accounts...',
        filters: {
            searchPlaceholder: 'Search by name, email, tax ID...',
            statusPlaceholder: 'Filter by status',
            entityTypePlaceholder: 'Filter by type',
            countryPlaceholder: 'Filter by country',
            userTypePlaceholder: 'Filter by user type',
            allTypes: 'All types',
            allStatuses: 'All statuses',
            allCountries: 'All countries',
        },
        table: {
            title: 'Accounts',
            description: 'Complete list of legal entities',
            headers: {
                userType: 'User Type',
                legalName: 'Legal Name',
                entityType: 'Entity Type',
                country: 'Country',
                status: 'Status',
                createdAt: 'Creation Date',
                actions: 'Actions',
            },
            edit: 'Edit',
            noAccounts: {
                title: 'No accounts found',
                message: 'Try modifying the search filters',
                emptyMessage: 'Start by creating your first account',
                createFirst: 'Create the first account',
            },
        },
        status: {
            active: 'Active',
            suspended: 'Suspended',
            inactive: 'Inactive',
        },
        confirmDelete: 'Are you sure you want to delete this account?',
    },
    form: {
        edit: {
            title: 'Edit Account',
            subtitle: 'Edit legal entity details',
        },
        create: {
            title: 'New Account',
            subtitle: 'Create a new legal entity',
        },
        loading: 'Loading account...',
        back: 'Back',
        sections: {
            general: 'General Information',
            address: 'Address',
            contacts: 'Contacts',
            notes: 'Additional Notes',
        },
        stepper: {
            step1: {
                title: 'Company Info',
                description: 'Basic company information and legal details',
            },
            step2: {
                title: 'Trade Details',
                description: 'Commercial information and trading preferences',
            },
        },
        fields: {
            userType: 'User Type',
            userTypePlaceholder: 'Select user type',
            legalName: 'Legal Name',
            legalNamePlaceholder: 'Enter legal name',
            entityType: 'Entity Type',
            entityTypePlaceholder: 'Select entity type',
            taxId: 'Tax ID / VAT Number',
            taxIdPlaceholder: 'Enter Tax ID or VAT number',
            status: 'Status',
            statusPlaceholder: 'Select status',
            street: 'Street',
            streetPlaceholder: 'Enter complete address',
            city: 'City',
            cityPlaceholder: 'Enter city',
            state: 'State/Province',
            statePlaceholder: 'Enter state or province',
            postalCode: 'Postal Code',
            postalCodePlaceholder: 'Enter postal code',
            country: 'Country',
            countryPlaceholder: 'Select country',
            email: 'Email',
            emailPlaceholder: 'name@company.com',
            phone: 'Phone',
            phonePlaceholder: '+1 555 123 4567',
            notes: 'Notes',
            notesPlaceholder: 'Enter additional notes about the account...',
            // Trade Details fields
            commodityType: 'Commodity Type',
            commodityTypePlaceholder: 'Select commodity type',
            commodityTypeOptions: {
                fresh: {
                    label: 'Fresh Products',
                    description: 'Fruits, vegetables, etc.',
                },
                soft: {
                    label: 'Soft Commodities',
                    description: 'Coffee, cocoa, sugar, etc.',
                },
                hard: {
                    label: 'Hard Commodities',
                    description: 'Metals, energy, etc.',
                },
            },
            specificProducts: 'Specific Products',
            specificProductsPlaceholder: 'Enter specific products (optional)',
            mainOrigins: 'Main Origins/Source Countries',
            mainOriginsPlaceholder: 'Select source countries',
            mainDestinations: 'Main Destinations/Markets',
            mainDestinationsPlaceholder: 'Select destination countries',
            monthlyContainerVolume: 'Monthly Container Volume',
            monthlyContainerVolumePlaceholder: 'Enter monthly volume',
        },
        actions: {
            cancel: 'Cancel',
            save: 'Save Changes',
            create: 'Create Account',
            next: 'Next',
            back: 'Back',
            previous: 'Previous',
        },
    },
};

